import { render, staticRenderFns } from "./CardWithThumbnail.vue?vue&type=template&id=05592aea&scoped=true&"
import script from "./CardWithThumbnail.vue?vue&type=script&lang=js&"
export * from "./CardWithThumbnail.vue?vue&type=script&lang=js&"
import style0 from "./CardWithThumbnail.vue?vue&type=style&index=0&id=05592aea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05592aea",
  null
  
)

export default component.exports